import React from 'react';
import * as s from './styles.scss';

export const PayPalIcon: React.FunctionComponent = () => (
  <img
    className={s.paypalLogo}
    src="https://www.wix.com/_partials/third-party/cashier-settings/cashier-payments/payPal.svg"
  />
);
PayPalIcon.displayName = 'PayPalIcon';
